import { render, staticRenderFns } from "./BellOffIcon.vue?vue&type=template&id=7c3d8a79&"
import script from "./BellOffIcon.vue?vue&type=script&lang=js&"
export * from "./BellOffIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports